// extracted by mini-css-extract-plugin
export var checkbox = "_8k-0";
export var circle = "_8k-3";
export var horizontalContainer = "_8k-7";
export var sm = "_8k-5";
export var switch0 = "_8k-2";
export var switchDisabled = "_8k-8";
export var switchEnabled = "_8k-1";
export var textSwitchContainer = "_8k-9";
export var textSwitchOption = "_8k-a";
export var textSwitchOptionSelected = "_8k-b";
export var verticalContainer = "_8k-6";
export var xs = "_8k-4";